var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"check",attrs:{"type":"checkbox"},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }